import React from 'react';

interface ButtonProps {
    onClick?: () => void;
    text: string;
    type?: 'button' | 'submit' | 'reset' | undefined;
    style?: React.CSSProperties
}
const Button: React.FC<ButtonProps> = ({ onClick, text, type, style }) => (
    <div className='button_border' style={style} >
        <button type={type} onClick={onClick}>{text}</button>
    </div>
);

export default Button;
